/* eslint-disable  import/no-cycle -- need */
import uuid from 'react-uuid';
import {
  getCallRequestOptions, normalizeAndDecode, postCallRequestOptions,
  getMetaData, encodeToBase64, encryptPayload,
  stringifyObjectValues,
  combineDataFields, getCurrentPage, formatDateByPattern, getPlainUuid,
} from './util';
import { performOperations } from '../Operations/Operations';

const getVal = require('lodash/get');

export const fetchS3Data = async (paramsObj, type = 'passcode', isV2 = false) => {
  // methods should know --> base url, pageType, cuid, docId, requestPayload
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      journeyId: paramsObj.journeyId,
      traceId: paramsObj.traceId,
    },
    body: encryptPayload(paramsObj.requestPayload),
  };
  const response = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}${isV2 ? '/v2' : ''}/s3/retrieve/${type}?cuid=${paramsObj.cuid}&page=${getCurrentPage()}`,
    requestOptions
  );
  return response;
};

export const saveDataToS3 = async (paramsObj, isV2 = false) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      journeyId: paramsObj.journeyId,
      traceId: paramsObj.traceId,
    },
    body: paramsObj.formData,
  };
  const response = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}${isV2 ? '/v2' : ''}/s3/upload?cuid=${paramsObj.cuid}&page=${getCurrentPage()}`,
    requestOptions
  );
  const result = await response.json();
  return result;
};

export const deleteFileFromS3 = async (paramsObj) => {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      journeyId: paramsObj.journeyId,
    },
  };
  const response = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}/s3/delete?cuid=${paramsObj.cuid}&page=${getCurrentPage()}&docKey=${paramsObj.fileId}`,
    requestOptions
  );
  return response;
};

export const checkReviewPortalStatus = async (paramsObj) => {
  const requestOptions = getCallRequestOptions(paramsObj.journeyId);
  const request = `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}/v2/reviewEnabled?cuid=${paramsObj.cuid}&page=${getCurrentPage()}`;
  const response = await fetch(`${request}`, requestOptions);
  const result = await response.json();
  if (result && result.statusIndicator === 'T') {
    return result.data === 'true';
  }
  return false;
};

/* eslint-disable max-params -- need */
export const sequenceIDApi = async (memberApiUrls, jId, cuid, format) => {
  const requestOptions = {

    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      traceId: uuid(),
      journeyId: jId,
      Format: format,
    },
  };
  const sequenceIDResponse = `${memberApiUrls}/iForms/unsecure/utility/idGenerator/SponsorID?cuid=${cuid}&page=${getCurrentPage()}`;
  const response = await fetch(`${sequenceIDResponse}`, requestOptions);
  const result = await response.json();
  if (result && result.statusIndicator === 'T') {
    return result.data;
  }
  return null;
};
/* eslint-enable max-params -- need */

export const fetchESignPdf = async (paramsObj) => {
  const requestOptions = {
    defer: true,
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(paramsObj.requestPayload),
  };
  const data = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}/pdf/generator?cuid=${paramsObj.cuid}&page=${getCurrentPage()}`,
    requestOptions
  );
  return data;
};

export const generateEsignPdfAndUpload = async (paramsObj) => {
  const requestOptions = {
    defer: true,
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(paramsObj.requestPayload),
  };
  const data = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}/v2/pdf/generatePDFAndUploadToS3?cuid=${paramsObj.cuid}&page=${getCurrentPage()}`,
    requestOptions
  );
  return data;
};

export const validateStatusOnWhatsapp = async (paramsObj) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(paramsObj.requestPayload),
  };
  const response = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}/whatsapp/updateUserStatus?cuid=${paramsObj.cuid}`,
    requestOptions
  );
  return response;
};

export const responseBuilder = async (url, requestOptions) => {
  try {
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    if (response.ok) {
      const standardResponse = {
        status: result.statusCode || response.status,
        statusIndicator: result.statusIndicator || 'T',
        message: result.message || 'Request successful',
      };
      // if result contains data then add the same field to standar response
      // else add the data field to standard response
      if (result.data) {
        standardResponse.data = result.data;
      } else {
        delete result.statusCode;
        delete result.statusIndicator;
        delete result.message;
        standardResponse.data = {
          ...result,
        };
      }
      return standardResponse;
    }
    return {
      status: response.status,
      statusIndicator: 'F',
      message: result?.message || response.statusText,
      data: null,
    };
  } catch (error) {
    // Handle network or runtime errors
    // console.error("Error during API call:", error);
    return {
      status: 500,
      statusIndicator: 'F',
      message:
        `An error occurred while making the API call -- ${error.message}`,
      data: null,
    };
  }
};

export const getMemberEmail = async (props) => {
  const {
    iformIntegrationUrls,
    memberInfo,
    journeyId,
    cuid,
  } = props.dataObject;
  const { loggerApiCall } = props.functionObject;
  const requestOptions = getCallRequestOptions(journeyId);
  const emailApi = `${iformIntegrationUrls}/iForms/secure/member/${memberInfo.accountToken}/email?cuid=${cuid}&page=${getCurrentPage()}`;
  const res = await responseBuilder(emailApi, requestOptions); // calls and handles the api
  if (res.statusIndicator === 'T') {
    loggerApiCall('status=getMemberEmailApiCallSuccess', 'info');
  } else if (res.statusIndicator === 'F') {
    loggerApiCall(`status=getMemberEmailApiCallFailed with statusCode=${res.status} message=${res.message}`, 'error');
  }
  return res;
};

export const lookupData = async (props) => {
  const {
    dataObject,
    callType,
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    formContainer,
    journeyId,
    cuid,
    iformIntegrationUrls,
  } = dataObject;

  const lookupType = formContainer.operations?.[apiCallerId]?.type;
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'lookupData';
  const onSuccessNavigate = formContainer.operations?.[apiCallerId]?.onSuccessNavigate;
  const onFailNavigate = formContainer.operations?.[apiCallerId]?.onFailNavigate;

  loggerApiCall(`status=${lookupType}LookupApiCalled for caller -- ${apiCallerId}`, 'info');
  setFormSubmissionPayload((prevPayload) => ({
    ...prevPayload,
    [`${apiCallerId}Status`]: 'inProgress',
    elemId: null,
  }));
  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, dataObject);
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const res = await responseBuilder(`${iformIntegrationUrls}/iForms/${formContainer.pageType}/lookUp/${lookupType}?cuid=${cuid}&page=${getCurrentPage()}`, requestOptions);
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      if (res.status === 206) {
        // call is successfull but no data found
        loggerApiCall(`status=${lookupType}LookupApiCallSuccess for caller -- ${apiCallerId} - No Data Found`, 'info');
        setFormSubmissionPayload((prevPayload) => ({
          ...prevPayload,
          [addDataAs]: null,
          [`${apiCallerId}Status`]: 'noData',
          elemId: null,
        }));
      } else {
        loggerApiCall(`status=${lookupType}LookupApiCallCallSuccess for caller -- ${apiCallerId}`, 'info');
        // if we have to perform custom operations on success-->
        if (formContainer.operations?.[apiCallerId]?.onSuccessOperations?.length > 0) {
          performOperations({
            ...props,
            operations: formContainer.operations[apiCallerId].onSuccessOperations,
            dataObject: {
              ...dataObject,
              [addDataAs]: res.data.lookUpData,
            },
          });
        }
        setFormSubmissionPayload((prevPayload) => ({
          ...prevPayload,
          [addDataAs]: res.data.lookUpData,
          [`${apiCallerId}Status`]: 'success',
          elemId: onSuccessNavigate,
        }));
      }
    } else {
      loggerApiCall(`status=${lookupType}LookupApiCallFailed with statusCode=${res.status} for caller -- ${apiCallerId} message=${res.message}`, 'error');
      setFormSubmissionPayload((prevPayload) => {
        delete prevPayload[addDataAs];
        return {
          ...prevPayload,
          [`${apiCallerId}Status`]: 'failed',
          elemId: onFailNavigate,
        };
      });
    }
  } else {
    return res;
  }
  return null;
};

export const handleDecryptApi = async ({
  decryptParams,
  params,
  memberApiUrls,
  jId,
  cuid,
}) => {
  // need to generate lookup payload
  const payloadParams = {};
  decryptParams.forEach((key) => {
    payloadParams[key] = normalizeAndDecode(params[key]);
  });
  const requestOptions = postCallRequestOptions(jId, payloadParams);
  const decryptApi = `${memberApiUrls}/iForms/secure/hiped/decryption?cuid=${cuid}&page=${getCurrentPage()}`;
  return responseBuilder(decryptApi, requestOptions);
};

export const finsTransactions = async (props) => {
  const {
    dataObject,
    callType,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    formContainer,
    journeyId,
    cuid,
    iformIntegrationUrls,
  } = dataObject;

  // delete previous fins response and update state
  setFormSubmissionPayload((prevPayload) => {
    delete prevPayload.finsTransactions;
    return {
      ...prevPayload,
      finsTransactionsStatus: 'inProgress',
      elemId: null,
    };
  });

  let onSuccessNavigate = null;
  if (formContainer.operations?.finsTransactions
    && Object.keys(formContainer.operations.finsTransactions)
      .includes('onSuccessNavigate')) {
    onSuccessNavigate = formContainer.operations.finsTransactions.onSuccessNavigate;
  }
  let onFailNavigate = 'error';
  if (formContainer.operations?.finsTransactions
    && Object.keys(formContainer.operations.finsTransactions)
      .includes('onFailNavigate')) {
    onFailNavigate = formContainer.operations.finsTransactions.onFailNavigate;
  }
  /*
  Request payload
  const requestKeys = {
    accountToken: '', --> mandatory
    type: 'DEBIT'/'CREDIT',
    "cycleIndex": 1,
    "merchantId": "",
    "amountGreaterOrEqual": 100,
    "amountGreater": 5000,
    "amountEqual": 100,
    "amountLess": 100,
    "amountLessOrEqual": 100,
    "customFilter": true --> if we are sending filters like amountGreater, amountLess etc
  };
  */

  const requestKeys = formContainer?.operations?.finsTransactions?.requestKeys || { accountToken: 'memberInfo.accountToken' };
  const requestPayload = getMetaData(requestKeys, dataObject);
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const finsTransactionApi = `${iformIntegrationUrls}/iForms/secure/fins/transactions?cuid=${cuid}&page=${getCurrentPage()}`;
  const res = await responseBuilder(finsTransactionApi, requestOptions);
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      loggerApiCall('status=finsTransactionsApiCallSuccess', 'info');
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        finsTransactions: res.data,
        finsTransactionsStatus: 'success',
        elemId: onSuccessNavigate,
      }));
    } else {
      loggerApiCall(`status=finsTransactionsApiCallFailed with statusCode=${res.status} message=${res.message}`, 'error');
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        finsTransactionsStatus: 'failed',
        elemId: onFailNavigate,
      }));
    }
  } else {
    if (res.statusIndicator === 'T') {
      loggerApiCall('status=finsTransactionsApiCallSuccess', 'info');
    } else if (res.statusIndicator === 'F') {
      loggerApiCall(`status=finsTransactionsApiCallFailed with statusCode=${res.status} message=${res.message}`, 'error');
    }
    return res;
  }
  return null;
};

export const creditStatus = async (props) => {
  const {
    callType,
    dataObject,
  } = props;
  const {
    iformIntegrationUrls,
    journeyId,
    formContainer,
    cuid,
    memberInfo,
  } = dataObject;

  const requestOptions = getCallRequestOptions(journeyId);
  const res = await responseBuilder(
    `${iformIntegrationUrls}/iForms/${formContainer.pageType}/css/${memberInfo.accountToken}/getCreditStatus?cuid=${cuid}&page=${getCurrentPage()}`,
    requestOptions);
  if (callType === 'standAlone') {
    // to be implemented based on use case
  } else if (callType === 'parallel') {
    return res;
  }
  return null;
};

export const cardVerify = async (props) => {
  // If apiName = cardVerifySubmit -->
  const {
    callType,
    dataObject,
    apiName,
    apiCallerId = 'cardVerify',
  } = props;
  const {
    formSubmissionPayload,
    memberInfo,
    iformIntegrationUrls,
    formContainer,
    cuid,
    journeyId,
  } = dataObject;
  const {
    loggerApiCall,
    setFormSubmissionPayload,
  } = props.functionObject;
  loggerApiCall(`status=calledCardVerifyApi endpoint=${apiCallerId}`, 'info');
  const requestPayload = {
    accountToken: memberInfo?.accountToken,
    cardNumber: formSubmissionPayload.cardNumber,
    cvv: encodeToBase64(formSubmissionPayload.cvv),
  };
  const cardVerifyOperations = formContainer.operations?.[apiCallerId];
  const operationType = cardVerifyOperations?.operationType || 'verifyCvv';
  if (cardVerifyOperations) {
    if (cardVerifyOperations.requestKeys) {
      const {
        combineFields,
        dob,
      } = cardVerifyOperations.requestKeys;
      if (combineFields?.length > 0) {
        combineFields.forEach((fieldObj) => {
          // combineDataFields
          const combinedField = combineDataFields(fieldObj.fieldsToCombine, dataObject);
          if (combinedField !== '') {
            requestPayload[fieldObj.addAs] = combinedField;
          }
        });
      }
      if (dob) {
        const { dobObject } = dob;
        const userDob = getVal(dataObject, dobObject.dobKey);
        const dobValueArray = userDob.split(dobObject.separator);
        requestPayload[dob.addAs] = `${dobValueArray[dobObject.yearIndex]}${dobValueArray[dobObject.monthIndex]}${dobValueArray[dobObject.dayIndex]}`;
      }
    }
  }
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const cardVerifyApi = `${iformIntegrationUrls}/iForms/${formContainer.pageType}/card/verification?cuid=${cuid}&operation=${operationType}&page=${getCurrentPage()}`;
  const res = await responseBuilder(cardVerifyApi, requestOptions);
  const data = {};
  if (res.statusIndicator === 'T') {
    loggerApiCall(`status=cardVerifyApiCallSuccess endpoint=${apiCallerId}`, 'info');
    data.cardVerifyStatus = 1;
  } else if (res.statusIndicator === 'F') {
    loggerApiCall(`status=cardVerifyApiCallFailed with statusCode=${res.status} endpoint=${apiCallerId} message=${res.message}`, 'error');
    data.cardVerifyStatus = 0;
  }
  if (callType === 'standAlone') {
    let onSuccessNavigate = apiName === 'cardVerifySubmit' ? 'submit' : 'continue';
    if (formContainer.operations?.cardVerify?.onSuccessNavigate) {
      onSuccessNavigate = formContainer.operations?.cardVerify?.onSuccessNavigate;
    }
    let onFailNavigate = null;
    if (formContainer.operations?.cardVerify?.onFailNavigate) {
      onFailNavigate = formContainer.operations.cardVerify.onFailNavigate;
    }
    if (res.statusIndicator === 'T') {
      setFormSubmissionPayload(
        { ...formSubmissionPayload, ...{ elemId: onSuccessNavigate, ...data } }
      );
    } else {
      setFormSubmissionPayload(
        { ...formSubmissionPayload, ...{ elemId: onFailNavigate, ...data } });
    }
  } else if (callType === 'parallel') {
    return {
      ...res,
      data,
    };
  }
  return null;
};

export const fetchItrackerStatus = async (props) => {
  const {
    callType,
    dataObject,
  } = props;
  const {
    formSubmissionPayload,
    iTrackerApiBaseUrls,
    formContainer,
    cuid,
    searchType,
  } = dataObject;
  const {
    loggerApiCall,
    handleContinue,
    handleClicApi,
  } = props.functionObject;
  const { itrackerConfig } = formContainer;
  if (itrackerConfig) {
    const {
      searchHeaderList,
      searchValueKeyList,
      clicCaseStatusToMoveToPage,
    } = itrackerConfig;
    if (searchHeaderList && searchValueKeyList) {
      const hashInput = searchHeaderList.map((header, i) => ({
        name: header,
        value: formSubmissionPayload[searchValueKeyList[i]],
      }));

      const logString = 'status=calledFetchItrackerStatus';
      loggerApiCall(logString, 'info');
      const requestPayload = {
        cuid,
        hashInput,
      };
      const requestOptions = {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encryptPayload(requestPayload),
      };
      const url = `${iTrackerApiBaseUrls}insightTracker/getStatus`;
      const res = await responseBuilder(url, requestOptions);
      if (res.statusIndicator === 'T') {
        loggerApiCall('status=fetchItrackerStatusApiCallSuccess', 'info');
      } else if (res.statusIndicator === 'F') {
        loggerApiCall(`status=fetchItrackerStatusApiCallFailed with statusCode=${res.status} message=${res.message}`, 'error');
      }
      if (callType === 'standAlone') {
        if (res.statusIndicator === 'T') {
          if (res.data.status === '200' && res.data.iformTrack) {
            if (clicCaseStatusToMoveToPage.status.map((val) => val.toUpperCase())
              .includes(res.data.iformTrack.trkStatNm.toUpperCase())) {
              handleContinue(clicCaseStatusToMoveToPage.successPage);
            }
          } else {
            handleClicApi(searchType);
          }
        } else {
          handleContinue(clicCaseStatusToMoveToPage.failurePage);
        }
      }
    } else {
      handleClicApi(searchType);
    }
  } else {
    handleClicApi(searchType);
  }
  return null;
};

export const saveItrackerStatus = async (props) => {
  const { dataObject, pageStatus, callType = 'standAlone' } = props;
  const {
    formSubmissionPayload,
    iTrackerApiBaseUrls,
    formContainer,
    cuid,
  } = dataObject;
  const { loggerApiCall } = props.functionObject;

  if (!pageStatus || !formContainer?.itrackerConfig?.isPageLevelTrackingEnabled
    || !iTrackerApiBaseUrls || !cuid) {
    return null;
  }

  const { itrackerConfig } = formContainer;
  const { searchHeaderList, searchValueList } = itrackerConfig;
  const hasSearchHeaders = Array.isArray(searchHeaderList) && searchHeaderList.length > 0;
  const hasSearchValues = Array.isArray(searchValueList) && searchValueList.length > 0;
  if (!hasSearchHeaders || !hasSearchValues) {
    loggerApiCall('status=saveItrackerStatusMissingConfig searchHeaderList or searchValueList undefined', 'error');
    return null;
  }

  if (searchHeaderList.length !== searchValueList.length) {
    loggerApiCall('status=saveItrackerStatusMissingConfig searchHeaderList and searchValueList length mismatch', 'error');
    return null;
  }

  const hashInput = searchHeaderList.map((header, i) => ({
    name: header,
    value: formSubmissionPayload[searchValueList[i]] || '',
  }));
  const trackingInputName = searchHeaderList.join(',');
  const trackingInputValue = searchValueList.map((key) => formSubmissionPayload[key] || '').join(',');
  const requestPayload = {
    cuid,
    hashInput,
    tracking_input_name: trackingInputName,
    tracking_input_value: trackingInputValue,
    status: pageStatus,
  };
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestPayload),
  };
  const url = `${iTrackerApiBaseUrls}insightTracker/saveStatus`;
  loggerApiCall(`status=calledSaveItrackerStatus pageStatus=${pageStatus}`, 'info');
  const res = await responseBuilder(url, requestOptions);
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      const hasDirectTrackerData = !!res?.data?.trkStatNm;
      if (hasDirectTrackerData) {
        const returnedStatus = res?.data?.trkStatNm || null;
        if (returnedStatus) {
          loggerApiCall(`status=saveItrackerStatusApiCallSuccess pageStatus=${pageStatus} trkStatNm=${returnedStatus}`, 'info');
        } else {
          loggerApiCall(`status=saveItrackerStatusApiCallSuccess pageStatus=${pageStatus}`, 'info');
        }
      } else {
        loggerApiCall(`status=saveItrackerStatusApiCallSuccess pageStatus=${pageStatus} - No Data Found`, 'info');
      }
    } else {
      loggerApiCall(`status=saveItrackerStatusApiCallFailed pageStatus=${pageStatus} with statusCode=${res.status} message=${res.message}`, 'error');
    }
  } else if (res.statusIndicator === 'T') {
    loggerApiCall(`status=saveItrackerStatusApiCallSuccess pageStatus=${pageStatus}`, 'info');
  } else if (res.statusIndicator === 'F') {
    loggerApiCall(`status=saveItrackerStatusApiCallFailed pageStatus=${pageStatus} with statusCode=${res.status} message=${res.message}`, 'error');
  }
  return res;
};

/* This method is used to fetch pincode details for IN */
export const getCityStateByPincode = async (props) => {
  const {
    dataObject,
    callType,
    keysToSave = {},
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    journeyId,
    iformIntegrationUrls,
  } = dataObject;

  const requestOptions = getCallRequestOptions(journeyId);
  const cityKey = keysToSave.city || 'city';
  const stateKey = keysToSave.state || 'state';
  const getCityStateByPincodeApi = `${iformIntegrationUrls}/iForms/unsecure/lms-connector/citystatebypincode?addressPincode=${props.value}&page=${getCurrentPage()}`;
  const res = await responseBuilder(getCityStateByPincodeApi, requestOptions);
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      loggerApiCall('status=getCityStateByPincodeSucess', 'info');
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        [cityKey]: res.data.cityNm,
        [stateKey]: res.data.stateNm,
      })
      );
    } else {
      loggerApiCall(`status=getCityStateByPincodeFailed with statusCode=${res.status} message=${res.message}`, 'error');
    }
  }
};

export const stageOneSubmit = async (props) => {
  const {
    apiCallerId,
    dataObject,
    functionObject,
  } = props;
  const {
    iformIntegrationUrls,
    journeyId,
    formContainer,
  } = dataObject;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
    setIsFormSubmission,
  } = functionObject;
  const onSuccessNavigate = formContainer.operations?.[apiCallerId]?.onSuccessNavigate;

  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);

  const requestOptions = postCallRequestOptions(journeyId, requestPayload);

  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'stage1Data';
  const addStatusAs = formContainer.operations?.[apiCallerId]?.addStatusAs || 'stage1Status';

  const stageApi = `${iformIntegrationUrls}/iForms/unsecure/lms-connector/stage1?page=${getCurrentPage()}`;
  const res = await responseBuilder(stageApi, requestOptions); // calls and handles the api
  if (res.statusIndicator === 'T') {
    setFormSubmissionPayload((prevPayload) => ({
      ...prevPayload,
      [addDataAs]: res.data,
      [addStatusAs]: res.status,
      [`${apiCallerId}Status`]: 'success',
      elemId: onSuccessNavigate,
    }));
  } else {
    loggerApiCall(`status=stage1LookupApiCallFailed with statusCode=${res.status} for caller -- ${apiCallerId} message=${res.message}`, 'error');
    setFormSubmissionPayload((prevPayload) => {
      delete prevPayload[addDataAs];
      return {
        ...prevPayload,
        [`${apiCallerId}Status`]: 'failed',
        [addStatusAs]: res.status,
        message: res.message,
        pcn_number: res.data?.pcn_number || '',
        elemId: 'error',
      };
    });
  }
  setIsFormSubmission(false);
};
export const resumeJourney = async (props) => {
  const {
    apiCallerId,
    dataObject,
    functionObject,
  } = props;
  const {
    iformIntegrationUrls,
    journeyId,
    formContainer,
  } = dataObject;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = functionObject;
  const onSuccessNavigate = formContainer.operations?.[apiCallerId]?.onSuccessNavigate;

  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'resumeFormData';

  const resumeFormAPI = `${iformIntegrationUrls}/iForms/unsecure/lms-connector/resume-form?page=${getCurrentPage()}`;
  const res = await responseBuilder(resumeFormAPI, requestOptions); // calls and handles the api

  if (res.statusIndicator === 'T') {
    loggerApiCall('status=resumeFlowApiCallSuccess', 'info');
    setFormSubmissionPayload((prevPayload) => ({
      ...prevPayload,
      [addDataAs]: res.data,
      firstName: res.data.first_name,
      lastName: res.data.last_name,
      ...res.data,
      [`${apiCallerId}Status`]: 'success',
      elemId: onSuccessNavigate,
    }));
  } else {
    loggerApiCall(`status=resumeFlowApiCallFailed with statusCode=${res.status} for caller -- ${apiCallerId} message=${res.message}`, 'error');
    setFormSubmissionPayload((prevPayload) => {
      delete prevPayload[addDataAs];
      return {
        ...prevPayload,
        [`${apiCallerId}Status`]: 'failed',
        message: res.message,
        elemId: null,
      };
    });
  }
};

export const fetchCardDetails = async (props) => {
  const {
    dataObject,
    callType,
    requestKeys = {},
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    journeyId,
    iformIntegrationUrls,
  } = dataObject;
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const checkValidLead = `${iformIntegrationUrls}/iForms/unsecure/lms-connector/card-details?page=${getCurrentPage()}`;
  const res = await responseBuilder(checkValidLead, requestOptions);
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      loggerApiCall('status=fetchValidSnRLeadSucess', 'info');
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        cardType: res.data.keyword,
        cardName: res.data.card_product_name,
      })
      );
    } else {
      loggerApiCall(`status=fetchValidSnRLeadFailed with statusCode=${res.status} message=${res.message}`, 'error');
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        [`${apiCallerId}StatusCode`]: res.status,
        [`${apiCallerId}Status`]: 'failed',
        message: res.message || 'We are unable to retrieve your application.',
        elemId: 'error',
      }));
    }
  }
};

/* eslint complexity: ["error", 25] -- need to increase complexity */
/* eslint-disable max-len -- need */
export const createClicCase = async (props) => {
  const {
    formSubmissionPayload,
    formContainer,
    memberInfo,
  } = props.dataObject;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
    setIsFormSubmission,
  } = props.functionObject;
  const {
    callType,
    apiCallerId = 'createClicCase',
  } = props;

  setFormSubmissionPayload((prevPayload) => {
    const newPayload = {
      ...prevPayload,
      createClicCaseStatus: 'inProgress',
      elemId: null,
    };
    return newPayload;
  });

  let onSuccessNavigate = 'continue';
  if (formContainer.operations?.[apiCallerId]
    && Object.keys(formContainer.operations[apiCallerId])
      .includes('onSuccessNavigate')) {
    onSuccessNavigate = formContainer.operations[apiCallerId].onSuccessNavigate;
  }
  let onFailNavigate = 'error';
  if (formContainer.operations?.[apiCallerId]
    && Object.keys(formContainer.operations[apiCallerId])
      .includes('onFailNavigate')) {
    onFailNavigate = formContainer.operations[apiCallerId].onFailNavigate;
  }
  loggerApiCall('status=calledCreateClicCaseApi', 'info');
  /**
   * Decide if we have to add clicSubType for this form ->
   * if yes --> decide which clicSubType --> based on memberInfo
   */
  let clicSubType = null;
  if (formContainer.operations?.[apiCallerId]?.isSubType && memberInfo) {
    const lob = memberInfo.accountTypes?.lineOfBusinessType;
    const paymentType = memberInfo.accountTypes?.paymentType;

    if (lob === 'CompanyCard') {
      clicSubType = 'sbs';
    } else if (lob === 'ConsumerCard' && paymentType === 'Revolve') {
      clicSubType = 'lending';
    } else if ((lob === 'ConsumerCard' && paymentType === 'ChargeCard') || lob === 'CorporateCard') {
      clicSubType = 'corp';
    }
  }

  if (!formSubmissionPayload.clicCaseNumber
    || (formSubmissionPayload.clicCaseNumber && clicSubType && formSubmissionPayload.clicSubType !== clicSubType)) {
    let requestPayload = {
      ...formSubmissionPayload,
      inquiryDate: new Date().toISOString(),
    };

    if (formContainer?.operations?.[apiCallerId]?.requestKeys) {
      requestPayload = getMetaData(formContainer?.operations?.[apiCallerId]?.requestKeys, props.dataObject);
    }
    requestPayload = stringifyObjectValues(requestPayload);
    const {
      iformIntegrationUrls,
      cuid,
      journeyId,
    } = props.dataObject;
    const requestOptions = postCallRequestOptions(journeyId, requestPayload);
    let createClicCaseApi = `${iformIntegrationUrls}/iForms/${formContainer.pageType}/oneclic/create/request?cuid=${cuid}&page=${getCurrentPage()}`;
    if (clicSubType) createClicCaseApi += `&subType=${clicSubType}`;
    const res = await responseBuilder(createClicCaseApi, requestOptions);
    setIsFormSubmission(false);
    if (callType === 'standAlone') {
      if (res.statusIndicator === 'T') {
        loggerApiCall('status=createClicCaseApiCallSuccess', 'info');
        setFormSubmissionPayload((prevPayload) => {
          let newPayload = {
            ...prevPayload,
            clicCaseNumber: res.data.caseNumber,
            createClicCaseStatus: 'success',
            elemId: onSuccessNavigate,
          };
          if (clicSubType) {
            newPayload = {
              ...newPayload,
              clicSubType,
            };
          }
          return newPayload;
        });
      } else {
        loggerApiCall(
          `status=createClicCaseApiCallFailed errorMsg=${res.message} status=${res.statusCode}`,
          'error'
        );
        setFormSubmissionPayload((prevPayload) => {
          const newPayload = {
            ...prevPayload,
            createClicCaseStatus: 'failed',
            elemId: onFailNavigate,
          };
          return newPayload;
        });
      }
    } else {
      return res;
    }
  } else if (callType === 'standAlone') {
    loggerApiCall('status=clic case has already been generated', 'info');
    setFormSubmissionPayload((prevPayload) => ({
      ...prevPayload,
      createClicCaseStatus: 'success',
      elemId: onSuccessNavigate,
    }));
  }
  return null;
};
/* eslint-enable max-len -- need */

/* eslint complexity: ["error", 45] -- need to increase complexity */
export const arketeam = async (props) => {
  const {
    dataObject,
    callType,
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    setEntityData,
    loggerApiCall,
    setIsFormSubmission,
  } = props.functionObject;
  const {
    formContainer,
    iformIntegrationUrls,
    journeyId,
  } = dataObject;

  // Route selection priority:
  // 1) honor explicit arketeamTaxCall=true (set by selectedCompany onChange flow)
  // 2) otherwise, fallback to SIREN numeric detection
  const hasExplicitTaxIdFlow = dataObject.formSubmissionPayload?.arketeamTaxCall === true;
  const sirenNumber = String(dataObject.formSubmissionPayload?.sirenNumber || '').trim();
  const isNumericSiren = /^\d+$/.test(sirenNumber);
  const shouldUseSirenAsTaxResourceId = !hasExplicitTaxIdFlow && sirenNumber && isNumericSiren;

  if (!hasExplicitTaxIdFlow) {
    if (sirenNumber && isNumericSiren) {
      dataObject.formSubmissionPayload.arketeamTaxCall = true;
    } else if (sirenNumber && !isNumericSiren) {
      dataObject.formSubmissionPayload.arketeamTaxCall = false;
    }
  }

  const valueMappings = formContainer.operations?.[apiCallerId]?.valueMappings || {};
  const dateFormatConfig = formContainer.operations?.[apiCallerId]?.dateFormatChangeFields || {};
  const dateFieldsToFormat = new Set(dateFormatConfig.fields || []);
  const outputDateFormat = dateFormatConfig.format || '';

  const getMappingDictionary = (fieldKey) => {
    if (fieldKey === 'country' || fieldKey === 'nationality') {
      return valueMappings.country || {};
    }

    if (fieldKey === 'roleInBusiness') {
      return valueMappings.roleInBusiness || {};
    }

    if (fieldKey === 'title') {
      return valueMappings.title || {};
    }

    return null;
  };

  const getMappedValue = (fieldKey, sourceValue) => {
    if (sourceValue === null || sourceValue === undefined || sourceValue === '') {
      return sourceValue;
    }

    const mapDictionary = getMappingDictionary(fieldKey);
    if (!mapDictionary) {
      return sourceValue;
    }

    const rawKey = String(sourceValue).trim();

    if (fieldKey === 'title') {
      const normalizedTitleKey = rawKey.toUpperCase();
      return mapDictionary[normalizedTitleKey] || mapDictionary[rawKey] || sourceValue;
    }

    if (fieldKey === 'country' || fieldKey === 'nationality') {
      const normalizedCountryKey = /^\d+$/.test(rawKey) ? rawKey.padStart(3, '0') : rawKey;
      return mapDictionary[rawKey] || mapDictionary[normalizedCountryKey] || sourceValue;
    }

    return mapDictionary[rawKey] || sourceValue;
  };

  const getFormattedDateValue = (fieldKey, sourceValue) => {
    if (!dateFieldsToFormat.has(fieldKey) || !outputDateFormat || !sourceValue) {
      return sourceValue;
    }

    const rawValue = String(sourceValue).trim();
    if (rawValue === '') {
      return sourceValue;
    }

    const isDateShape = (value, separator, expectedLengths) => {
      const parts = value.split(separator);
      return parts.length === expectedLengths.length
        && parts.every((part, index) => /^\d+$/.test(part) && part.length === expectedLengths[index]);
    };

    if (isDateShape(rawValue, '/', [2, 2, 4]) && outputDateFormat === 'DD/MM/YYYY') {
      return rawValue;
    }

    const normalizedIsoDate = rawValue.split('T')[0];

    if (isDateShape(normalizedIsoDate, '-', [4, 2, 2])) {
      return formatDateByPattern(normalizedIsoDate, 'YYYY-MM-DD', outputDateFormat);
    }

    if (isDateShape(rawValue, '/', [4, 2, 2])) {
      return formatDateByPattern(rawValue, 'YYYY/MM/DD', outputDateFormat);
    }

    if (isDateShape(rawValue, '-', [2, 2, 4])) {
      return formatDateByPattern(rawValue, 'DD-MM-YYYY', outputDateFormat);
    }

    return sourceValue;
  };

  const normalizeArketeamResponse = (sourceValue) => {
    if (Array.isArray(sourceValue)) {
      return sourceValue.map((item) => normalizeArketeamResponse(item));
    }

    if (sourceValue && typeof sourceValue === 'object') {
      return Object.keys(sourceValue).reduce((normalizedObject, key) => {
        const currentValue = sourceValue[key];

        if (currentValue && typeof currentValue === 'object') {
          normalizedObject[key] = normalizeArketeamResponse(currentValue);
        } else {
          normalizedObject[key] = getFormattedDateValue(
            key,
            getMappedValue(key, currentValue)
          );
        }

        return normalizedObject;
      }, {});
    }

    return sourceValue;
  };

  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'arketeamResponse';
  const requestKeys = dataObject.formSubmissionPayload.arketeamTaxCall
    ? formContainer?.operations?.[apiCallerId]?.requestKeys?.taxId || {}
    : formContainer?.operations?.[apiCallerId]?.requestKeys?.companyInfo || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);

  // Direct numeric SIREN route calls taxId without a selected company,
  // so tax resourceId must come from sirenNumber for that path only.
  if (dataObject.formSubmissionPayload.arketeamTaxCall && shouldUseSirenAsTaxResourceId) {
    requestPayload.resourceId = sirenNumber;
  }

  if (requestPayload.contextInformation) {
    requestPayload.contextInformation = JSON.stringify(requestPayload.contextInformation);
  }
  const payload = {
    head: {
      traceId: uuid(),
      span: 'iForm6513',
      journeyId,
    },
    body: {
      ...requestPayload,
    },
  };
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(payload),
  };
  loggerApiCall?.(
    `status=arketeamApiCalled for caller -- ${apiCallerId}`,
    'info'
  );

  if (setIsFormSubmission) {
    setIsFormSubmission(true);
  }

  // Call Arketeam API
  const res = dataObject.formSubmissionPayload.arketeamTaxCall ? await responseBuilder(
    `${iformIntegrationUrls}/iForms/unsecure/api/v1/functions/readInboundAggregatedUserData/taxId`,
    requestOptions
  ) : await responseBuilder(
    `${iformIntegrationUrls}/iForms/unsecure/api/v1/functions/readInboundAggregatedUserData/companyInfo`,
    requestOptions
  );

  if (setIsFormSubmission) {
    setIsFormSubmission(false);
  }

  if (res.statusIndicator === 'T') {
    if (callType === 'standAlone') {
      const responseData = normalizeArketeamResponse(res.data || {});
      const tablePrefillConfig = formContainer.operations?.[apiCallerId]?.tablePrefillConfig;
      let tablePrefillConfigs = [];
      if (Array.isArray(tablePrefillConfig)) {
        tablePrefillConfigs = tablePrefillConfig;
      } else if (tablePrefillConfig) {
        tablePrefillConfigs = [tablePrefillConfig];
      }

      if (
        dataObject.formSubmissionPayload.arketeamTaxCall
        && setEntityData
        && tablePrefillConfigs.length > 0
      ) {
        tablePrefillConfigs.forEach((prefillConfig) => {
          if (!prefillConfig?.sourceListKey || !prefillConfig?.targetEntityKey) {
            return;
          }

          const sourceRows = getVal(responseData, prefillConfig.sourceListKey, []);
          if (!Array.isArray(sourceRows) || sourceRows.length === 0) {
            return;
          }

          const mappedRows = sourceRows.map((sourceRow, sourceIndex) => {
            const mappedRow = {};
            const fieldMapping = prefillConfig.fieldMapping || {};
            Object.keys(fieldMapping).forEach((targetKey) => {
              mappedRow[targetKey] = getVal(sourceRow, fieldMapping[targetKey], '');
            });
            // Stamp the row's position in sourceRows (not entityData's own array, which can
            // be reordered/spliced during edit/delete) so prefillStyleConfig.matchAPIKey can
            // later look this row's raw record back up from the single shared raw list below.
            /* eslint-disable-next-line no-underscore-dangle -- internal marker */
            mappedRow.__rawApiIndex = sourceIndex;

            const staticFields = prefillConfig.staticFields || {};
            Object.keys(staticFields).forEach((targetKey) => {
              mappedRow[targetKey] = staticFields[targetKey];
            });

            const addStaticConfig = prefillConfig.addStaticFieldsToFieldMapping;
            if (addStaticConfig && typeof addStaticConfig === 'object') {
              Object.keys(addStaticConfig).forEach((fieldKey) => {
                const fieldValue = addStaticConfig[fieldKey];
                mappedRow[fieldKey] = fieldValue === 'uuid' ? getPlainUuid() : fieldValue;
              });
            }

            if (prefillConfig.displayNameField && Array.isArray(prefillConfig.displayNameKeys)) {
              const displayName = prefillConfig.displayNameKeys
                .map((key) => getVal(sourceRow, key, ''))
                .filter((val) => val !== null && val !== undefined && String(val).trim() !== '')
                .join(prefillConfig.displayNameSeparator || ' ')
                .trim();
              const capitalizedDisplayName = displayName
                .split(/\s+/)
                .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
                .join(' ')
                .trim();
              if (capitalizedDisplayName) {
                mappedRow[prefillConfig.displayNameField] = capitalizedDisplayName;
              }
            }

            return mappedRow;
          });

          setEntityData((prevEntityData) => ({
            ...prevEntityData,
            [prefillConfig.targetEntityKey]: mappedRows,
          }));

          // No separate raw-data storage needed: the raw sourceRows already live at
          // sourceListKey inside the responseData tree, which is preserved as-is under
          // formSubmissionPayload[`${addDataAs}_taxId`] below. prefillStyleConfig can
          // resolve matchAPIKey via that existing bucket + this row's __rawApiIndex.

          if (prefillConfig.hideSectionFlagKey) {
            setFormSubmissionPayload((prevPayload) => ({
              ...prevPayload,
              [prefillConfig.hideSectionFlagKey]: 'Yes',
              elemId: null,
            }));
          }
        });
      }

      const payloadPrefillConfig = formContainer.operations?.[apiCallerId]?.payloadPrefillConfig;
      const shouldApplyPayloadPrefill = payloadPrefillConfig
        && (
          !payloadPrefillConfig.applyOnTaxCallOnly
          || dataObject.formSubmissionPayload.arketeamTaxCall
        );

      if (shouldApplyPayloadPrefill) {
        const fieldMapping = payloadPrefillConfig.fieldMapping || {};
        const mappedPayloadFields = {};

        Object.keys(fieldMapping).forEach((targetKey) => {
          mappedPayloadFields[targetKey] = getVal(responseData, fieldMapping[targetKey], '');
        });

        if (Object.keys(mappedPayloadFields).length > 0) {
          setFormSubmissionPayload((prev) => ({
            ...prev,
            ...mappedPayloadFields,
            elemId: null,
          }));
        }
      }

      setFormSubmissionPayload((prev) => {
        const isTaxIdFlow = dataObject.formSubmissionPayload.arketeamTaxCall;
        const responseUsers = responseData?.userInformation?.users;
        const firstUser = Array.isArray(responseUsers)
          && responseUsers.length > 0 ? responseUsers[0] : null;
        const fallbackSelectedCompany = firstUser
          ? getVal(firstUser, 'businessInformation.businessId', '')
          : '';
        const hasSelectedCompanyObject = prev.selectedCompanyObject
          && Object.keys(prev.selectedCompanyObject).length > 0;

        return {
          ...prev,
          [isTaxIdFlow ? `${addDataAs}_taxId` : `${addDataAs}_companyInfo`]: responseData?.userInformation,
          selectedCompanyObject: isTaxIdFlow && !hasSelectedCompanyObject
            ? firstUser || prev.selectedCompanyObject
            : prev.selectedCompanyObject,
          selectedCompany: isTaxIdFlow && !prev.selectedCompany
            ? fallbackSelectedCompany
            : prev.selectedCompany,
          elemId: null,
        };
      });
      loggerApiCall?.(`status=arketeamSuccess for ${apiCallerId}`, 'info');
    }
  } else {
    setFormSubmissionPayload((prev) => ({
      ...prev,
      [`${apiCallerId}Message`]: res.message,
      elemId: 'error',
    }));
    loggerApiCall?.(
      `arketeam FAILED (no payload) with statusCode=${res.status} message=${res.message}`,
      'error'
    );
  }
  return null;
};

export const ibanVerification = async (props) => {
  const {
    dataObject,
    callType,
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    formContainer,
    iformIntegrationUrls,
    journeyId,
    cuid,
  } = dataObject;
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'ibanVerification';
  const responseConditions = formContainer.operations?.[apiCallerId]?.responseConditions;
  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  loggerApiCall(
    `status=IBANVerificationApiCalled for caller -- ${apiCallerId}`,
    'info'
  );

  // Call IBAN Verification API
  const res = await responseBuilder(
    `${iformIntegrationUrls}/iForms/secure/ebim/bankVerification?cuid=${cuid}&page=${getCurrentPage()}`,
    requestOptions
  );
  if (res.statusIndicator === 'T') {
    if (callType === 'standAlone') {
      const message = res.data?.reasons?.reduce((msg, reason) => {
        if (msg === '') {
          msg += reason.message;
        } else {
          msg = `${msg} | ${reason.message}`;
        }
        return msg;
      }, '');
      const responseCodes = res.data?.reasons?.map((r) => r.code) || [];
      /* eslint-disable no-restricted-syntax -- need */
      for (const condition of responseConditions[res.data?.status]) {
        const updatedPayload = {
          [addDataAs]: res.data,
          [`${apiCallerId}Status`]: res.data?.status?.toLowerCase(),
          elemId: condition?.onFindNavigate,
        };
        if (message) {
          updatedPayload[`${apiCallerId}Message`] = message;
        }
        if (responseCodes.length > 0 && condition?.codes?.length > 0) {
          if (responseCodes.some((code) => condition?.codes?.includes(code))) {
            setFormSubmissionPayload((prev) => ({
              ...prev,
              ...updatedPayload,
            }));
            loggerApiCall(
              `IBANVerification FAILED for ${apiCallerId}`,
              'error'
            );
            break;
          }
        } else {
          setFormSubmissionPayload((prev) => ({
            ...prev,
            ...updatedPayload,
          }));
        }
      }
      /* eslint-enable no-restricted-syntax -- need */
    }
  } else {
    setFormSubmissionPayload((prev) => ({
      ...prev,
      [`${apiCallerId}Message`]: res.message,
      elemId: 'error',
    }));
    loggerApiCall(
      `IBANVerification FAILED (no payload) with statusCode=${res.status} message=${res.message}`,
      'error'
    );
  }
  return null;
};

export const aceVerification = async (props) => {
  const {
    callType,
    dataObject,
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    iformIntegrationUrls,
    journeyId,
    formContainer,
    cuid,
  } = dataObject;
  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  const onSuccessNavigate = formContainer?.operations?.[apiCallerId]?.onSuccessNavigate;
  const onFailureNavigate = formContainer?.operations?.[apiCallerId]?.onFailureNavigate;
  const onInvalidCaseNavigate = formContainer?.operations?.[apiCallerId]?.onInvalidCaseNavigate;
  const responseCodes = formContainer.operations?.[apiCallerId]?.responseCodes;
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'tinVerification';
  loggerApiCall(`status=aceVerification called for caller -- ${apiCallerId}`, 'info');
  const res = await responseBuilder(
    `${iformIntegrationUrls}/iForms/${formContainer.pageType}/ace/tinVerification?cuid=${cuid}&page=${getCurrentPage()}`,
    requestOptions
  );

  if (callType === 'parallel') {
    return res;
  }
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      loggerApiCall(
        'status=aceVerification success', 'info'
      );
      const aceStatus = res.data?.awaitingDocument;
      setFormSubmissionPayload((prevPayload) => {
        const newPayload = {
          ...prevPayload,
          [addDataAs]: res,
          [`${apiCallerId}Status`]: aceStatus ? 'Success' : 'DocumentReceived',
          elemId: aceStatus ? onSuccessNavigate : onInvalidCaseNavigate,
        };
        return newPayload;
      });
    } else if (res.statusIndicator === 'F') {
      const isInvalidCode = responseCodes.includes(res.status);
      setFormSubmissionPayload((prev) => ({
        ...prev,
        [`${apiCallerId}Message`]: res.message,
        [`${apiCallerId}Status`]: 'Failed',
        elemId: isInvalidCode ? onInvalidCaseNavigate : onFailureNavigate,
      }));
      loggerApiCall(
        `status=aceVerification FAILED (no payload) with statusCode=${res.status} message=${res.message}`,
        'error'
      );
    }
  }
  return null;
};

export const c360Verification = async (props) => {
  const {
    callType,
    dataObject,
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    iformIntegrationUrls,
    journeyId,
    formContainer,
    cuid,
  } = dataObject;
  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  const onSuccessNavigate = formContainer?.operations?.[apiCallerId]?.onSuccessNavigate;
  const onFailureNavigate = formContainer?.operations?.[apiCallerId]?.onFailureNavigate;
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'c360Verification';
  loggerApiCall(
    `status=c360Verification called for caller -- ${apiCallerId}`,
    'info'
  );
  const res = await responseBuilder(
    `${iformIntegrationUrls}/iForms/secure/c360/inquiry?cuid=${cuid}`,
    requestOptions
  );
  if (callType === 'parallel') {
    return res;
  }
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      loggerApiCall(
        'status=c360Verification success', 'info'
      );
      setFormSubmissionPayload((prevPayload) => {
        const newPayload = {
          ...prevPayload,
          [addDataAs]: res.data,
          elemId: onSuccessNavigate,
        };
        return newPayload;
      });
    } else {
      setFormSubmissionPayload((prev) => ({
        ...prev,
        [`${apiCallerId}Message`]: res.message,
        elemId: onFailureNavigate,
      }));
      loggerApiCall(
        `status=c360Verification FAILED (no payload) with statusCode=${res.status} message=${res.message}`,
        'error'
      );
    }
  }
  return null;
};
const triggerPostOperations = (rawResponse, postOperationsProps, responseObject) => {
  /* eslint-disable no-restricted-syntax -- need */

  const {
    postOperations,
    apiCallerId,
  } = postOperationsProps;

  for (const operation of postOperations) {
    const {
      type,
      compareWith,
      compareValue,
      respStatus,
      respAction,
      ignoreOtherActions,
    } = operation;
    let exitFromAfterActions = false;
    switch (type) {
      case 'compare':
        if (getVal(rawResponse, compareWith) === compareValue) {
          responseObject = {
            ...responseObject,
            [`${apiCallerId}Status`]: respStatus,
            elemId: respAction,
          };
          if (ignoreOtherActions) {
            exitFromAfterActions = true;
          }
        }
        break;
      default:
        break;
    }
    if (exitFromAfterActions) break;
  }
  /* eslint-enable no-restricted-syntax -- need */
  return responseObject;
};

export const triggerAPI = async (props) => {
  const {
    dataObject,
    functionObject,
    apiCallerId,
  } = props;

  const {
    journeyId,
    formContainer,
  } = dataObject;

  const {
    loggerApiCall,
    setFormSubmissionPayload,
  } = functionObject;

  const apiDetails = formContainer.operations?.[apiCallerId];
  const {
    addDataAs = null,
    onSuccessStatus,
    onFailStatus,
    onSuccessNavigate,
    onFailNavigate,
    onSuccessMessage,
    onFailMessage,
    requestKeys = {},
    stringsToReplaceInURL,
    additionalOperations = {},
  } = apiDetails;

  let {
    apiURL,
  } = apiDetails;

  const {
    onSuccessOperations = null,
    onFailOperations = null,
  } = additionalOperations;

  let requestOptions = {};
  if (apiDetails?.method === 'POST') {
    const requestPayload = getMetaData(requestKeys, dataObject);
    requestOptions = postCallRequestOptions(journeyId, requestPayload);
  } else {
    requestOptions = getCallRequestOptions(journeyId);
  }
  if (stringsToReplaceInURL) {
    stringsToReplaceInURL.forEach((replaceData) => {
      apiURL = apiURL.replace(replaceData.key, getVal(dataObject, replaceData.value));
    });
  }
  const res = await responseBuilder(apiURL, requestOptions); // calls and handles the api
  const isSuccess = res.statusIndicator === 'T';

  const apiStatus = isSuccess ? onSuccessStatus : onFailStatus;
  const defaultMessage = isSuccess ? onSuccessMessage : onFailMessage;
  const onNavigate = isSuccess ? onSuccessNavigate : onFailNavigate;
  const postOperations = isSuccess ? onSuccessOperations : onFailOperations;

  let apiResponseObject = {
    [`${apiCallerId}Status`]: apiStatus,
    [`${apiCallerId}StatusCode`]: res.status,
    [`${apiCallerId}Message`]: res.message || defaultMessage,
    elemId: onNavigate,
  };

  if (postOperations) {
    const postOperationsProps = {
      postOperations,
      apiCallerId,
    };
    apiResponseObject = triggerPostOperations(
      res.data,
      postOperationsProps,
      apiResponseObject
    );
  }

  if (res.statusIndicator === 'T') {
    loggerApiCall('status=triggerApiCallSuccess', 'info');
    if (addDataAs) {
      apiResponseObject = {
        ...apiResponseObject,
        [addDataAs]: res.data,
      };
    }
  } else if (res.statusIndicator === 'F') {
    loggerApiCall(`status=triggerApiCallFailed with statusCode=${res.status} message=${res.message}`, 'error');
  }

  setFormSubmissionPayload((prevPayload) => ({
    ...prevPayload,
    ...apiResponseObject,
  }));

  return res;
};
/* eslint-enable  import/no-cycle -- need */
